import { render, staticRenderFns } from "./FeedHeader.vue?vue&type=template&id=4fca47da&"
import script from "./FeedHeader.vue?vue&type=script&lang=js&"
export * from "./FeedHeader.vue?vue&type=script&lang=js&"
import style0 from "./FeedHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports